import React, { useState } from 'react';
import { Flex, Box, Text } from '@rebass/emotion';
import { FormattedMessage } from 'react-intl';

import { TYPO3_URL } from '../../../config/client.config';
import styles from './Header.styles';
import InjectIntl from '../InjectIntl/InjectIntl';
import messages from './Header.messages';
import Cart from '../Cart';
import AccountWidget from '../AccountWidget';
import { convertToUrlLocale } from '../../helpers/locale';

const Header = (): JSX.Element => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  return (
    <InjectIntl>
      {({ locale }) => {
        const urlLocale = convertToUrlLocale(locale);
        const NAV_LINKS = {
          products: `/${urlLocale}/catalog/`,
          community: `/${urlLocale}/community/`,
          support: `http://support.native-instruments.com/hc/`,
        };

        return (
          <header css={styles.header}>
            <Flex css={styles.contentWrapper}>
              <Flex css={styles.logoContainer}>
                <Box mr={3}>
                  <a css={styles.logo} href={TYPO3_URL}>
                    <span>Native Instruments</span>
                  </a>
                </Box>
              </Flex>
              <Flex css={styles.navContainer}>
                <nav css={styles.nav(isMenuOpen)}>
                  <ul css={styles.navUl}>
                    {Object.keys(messages).map((link) => {
                      return (
                        <li css={styles.navLi} key={link}>
                          <a css={styles.navLink} href={NAV_LINKS[link]}>
                            <FormattedMessage {...messages[link]} />
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </nav>
              </Flex>

              <Flex css={styles.actionButtonContainer}>
                <Flex css={styles.accountContainer}>
                  <Box mr={3}>
                    <AccountWidget />
                  </Box>
                  <Box mr={[3, 0, 0]}>
                    <Cart />
                  </Box>
                </Flex>
                <Flex
                  css={styles.mobileMenu}
                  onClick={() => setMenuOpen(!isMenuOpen)}
                >
                  <Text pr={2}>MENU</Text>
                  <Box css={styles.hamburger(isMenuOpen)}>
                    <span />
                    <span />
                    <span />
                  </Box>
                </Flex>
              </Flex>
            </Flex>
          </header>
        );
      }}
    </InjectIntl>
  );
};

export default Header;
